import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Center, Flex, Text, useBoolean } from '@chakra-ui/react'

import { InformativeDSLayer, useInformativeLayerImage } from 'components/informativeLayer'
import HeaderOffRoad from 'views/Layout/headerOffRoad/HeaderOffRoad'


const SubscriptionResumenSuccess: React.FC = () => {
  const { state }: any = useLocation() || {}
  const { hasBankPhysical = true } = state || {}
  const [isLoading, setIsLoading] = useBoolean(true)
  
  const title = '¡Confirmaste la solicitud con éxito!'
  const image = useInformativeLayerImage('EXIT')

  const supportLabel = () => {
    return (
      <Center w='100%' mt={0}>
        <Flex flexDirection={'column'} textStyle={['bodySm','bodyLg']}>
          <Text data-testid='info-paragraph-detail' color='#292D36'  textAlign='center' >
            Le avisaremos al suscriptor que completaste la tarea.
          </Text>
          { hasBankPhysical  && <Text data-testid="info-recoveryUserErrorOperator-link" textAlign='center'>
            Si tenés bancos con suscripción física, te solicitará firmar documentación.
          </Text>}
        </Flex>
      </Center>
    )
  } 
   
  useEffect(() => {
    setIsLoading.off()
  }, [])


  return (
    <>
      <HeaderOffRoad />    
      <InformativeDSLayer 
        isLoading={isLoading}
        title={<Text data-testid='info-title-detail' textStyle={['h6', 'h4Bold']} fontWeight='700' color='#3B414E' textAlign='center' >{title}</Text>}
        paragraph={supportLabel()}   
        image={image}
      />
    </>
  )
}

export default SubscriptionResumenSuccess
